import { useCookies } from "react-cookie";
import Breadcrumb from "../../Breadcrumb/Breadcrumb";
import HonariButton from "../../Button/HonariButton";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import * as Constants from "../../../constants/urls";
import { toast } from "react-toastify";
import { wait } from "@testing-library/react";
import moment from "moment-jalaali";
import Spinner from "../../Spinner/Spinner";

export default function FactorChecking() {
  const id = useParams().id;
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(undefined);
  const [order, setOrder] = useState(undefined);
  const [notChecked, setNotChecked] = useState([]);
  const [checked, setChecked] = useState([]);
  const [cookies, setCookie, removeCookie] = useCookies();
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);

  const render = () => {
    let json = [];
    if (data == undefined) return;
    data.map((item) => {
      for (let i = 0; i < item.count; i++) {
        json.push({
          barcode: item.pack.barCode,
          label: item.pack.label,
          image: item.product.prodID,
          name: item.product.prodName_fa,
        });
      }
    });
    setNotChecked(json);
    setChecked([]);
  };
  function getData() {
    setLoading(true);
    const url = Constants.apiUrl + "/api/order/getOrderItem/" + id;
    axios
      .get(url, {
        headers: {
          Authorization: "Bearer " + cookies.user_server_token,
        },
      })
      .then((r) => {
        setData(r.data.items);
        setOrder(r.data.order);
        setLoading(false);

      })
      .catch((e) => {
        setLoading(false);

      });
  }
  useEffect(() => {
    getData();
  }, [id]);
  useEffect(() => {
    render();
  }, [data]);

  const handleKeyDown = async (event) => {
    if (event.key === "Enter") {
      const foundIndex = notChecked.findIndex(
        (item) => item.barcode === inputValue.trim()
      );

      if (foundIndex !== -1) {
        // اضافه کردن آیتم به استیت checked
        const foundItem = notChecked[foundIndex];
        setChecked((prevChecked) => [foundItem,...prevChecked]);

        // حذف فقط یک مورد از notChecked
        setNotChecked((prevNotChecked) => {
          const updatedNotChecked = [...prevNotChecked];
          updatedNotChecked.splice(foundIndex, 1);
          return updatedNotChecked;
        });
      } else {
        const foundIndex2 = checked.findIndex(
          (item) => item.barcode === inputValue.trim()
        );
        if (foundIndex2 !== -1) {
          await soundAlert().then(() => {
             alert("محصول در لیست چک شده ها وجود دارد");
          });
        } else {
          await soundAlert().then(() => {
            alert(" محصول یافت نشد");
          });
        }
      }

      // خالی کردن مقدار ورودی
      setInputValue("");
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  },[])
  
  useEffect(() => {
    if (notChecked.length == 0 && checked.length != 0) {
      endCheckout();
    }
  }, [notChecked]);

  const soundAlert = async () => {
    const audio = new Audio(
      Constants.imagesBsaeUrl + "/image/beep-short.mp3"
    );
   await audio.play();
  };
  useEffect(() => {
    const handleDocumentClick = () => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    };

    // افزودن رویداد کلیک به کل صفحه
    document.addEventListener("click", handleDocumentClick);

    // پاک کردن رویداد هنگام خروج از کامپوننت
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const endCheckout = () => {
    if (notChecked.length > 0) {
      soundAlert();

      alert("موارد چک نشده هنوز باقی مانده اند");
      return;
    }
    const url = Constants.apiUrl + "/api/order/checkOrder";
    axios
      .post(
        url,
        {
          orderId: id,
          checker: userId,
        },
        {
          headers: {
            Authorization: "Bearer " + cookies.user_server_token,
          },
        }
      )
      .then((r) => {
        navigate("/admin/orders/check");
      })
      .catch((e) => {
        toast.error(e.response.data);
      });
  };
  return (
    <>
      <Breadcrumb title={"چک کردن"} />
      <div>
        <HonariButton onClick={endCheckout} className={"w-full text-lg"}>
          همه رو تیک زدم
        </HonariButton>
      </div>
      <div className="flex flex-col divide-y justify-between bg-white p-2 text-lg">
        <div className="flex py-2 text-gray-500">
          <span>شماره سبد : </span>
          <span>{order?.basket_barcode}</span>
        </div>
        <div className="flex py-2 text-gray-500">
          <span>نام مشتری : </span>
          {order && (
            <span>
              {order?.order_info?.fname ??
                "" + " " + order?.order_info?.lname ??
                ""}
            </span>
          )}
        </div>
        <div className="flex py-2 text-gray-500">
          <span>شیوه ارسال : </span>
          <span>{order?.delivermode?.name ?? ""}</span>
        </div>
        <div className="flex py-2 text-gray-500">
          <span> زمان ارسال   : </span>
          <span>
          {
               order?.order_info?.post_time != "0" ? moment(order?.order_info?.post_time * 1000).format('jYYYY/jM/jD H:m:s') : "---"
          }
            </span>
        </div>
        <div className="flex py-2 text-gray-500">
          <span>شهر : </span>
          <span>{order?.order_info?.city?.city ?? ""}</span>
        </div>
      </div>

      <div>
        <input
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          ref={inputRef}
          placeholder="بارکد بسته"
          type="text"
          value={inputValue}
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
        />
      </div>
      {
        loading && <div className="flex justify-center items-center"><div className="w-32 h-32"><Spinner /></div></div>
      }
      <div className="grid  grid-cols-1 sm:grid-cols-2 gap-20">
        <div className="flex flex-col gap-5 mt-10">
          {notChecked &&
            notChecked.map((item) => (
              <>
                <div className="border rounded flex items-center  gap-10 bg-red-50">
                  <div className="w-40 h-40">
                    <img
                      src={
                        Constants.imagesBsaeUrl +
                        "/image/resizeTest/shop/_1000x/thumb_" +
                        item.image +
                        ".jpg"
                      }
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "2px",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                  <div className="flex flex-col text-right gap-5">
                    <span className="text-lg">{item.name}</span>
                    <span>{item.label}</span>
                    <span className="font-bold">{item.barcode}</span>
                  </div>
                </div>
              </>
            ))}
        </div>
        <div className="flex flex-col gap-5 mt-10">
          {checked &&
            checked.map((item) => (
              <>
                <div className="border rounded flex items-center  gap-10 bg-blue-50 ">
                  <div className="w-40 h-40">
                    <img
                      src={
                        Constants.imagesBsaeUrl +
                        "/image/resizeTest/shop/_1000x/thumb_" +
                        item.image +
                        ".jpg"
                      }
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "2px",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                  <div className="flex flex-col text-right gap-5">
                    <span className="text-lg">{item.name}</span>
                    <span>{item.label}</span>
                    <span className="font-bold">{item.barcode}</span>
                  </div>
                </div>
              </>
            ))}
        </div>
      </div>
      <div>
        <HonariButton className={"w-full text-lg"} onClick={endCheckout}>
          همه رو تیک زدم
        </HonariButton>
      </div>
    </>
  );
}
